{
  "title": "Account & Profile",
  "languageSection": "Language & region",
  "preferredLanguage": "Preferred language",
  "preferredLanguageHelp": "Used across the site and for the emails we send you.",
  "profile": "Public profile",
  "notifications": "Notifications",
  "emailPreferences": "Email preferences"
}
